import { styled as s, Modal as d, Fade as i, Box as a } from "@mui/material";
import { jsx as o } from "react/jsx-runtime";
const c = s(d)`
  .MuiBox-root {
    outline: none;
  }
`, x = (t) => {
  const {
    children: r,
    className: n,
    open: e,
    ...l
  } = t;
  return /* @__PURE__ */ o(c, {
    closeAfterTransition: !0,
    open: e,
    ...l,
    children: /* @__PURE__ */ o(i, {
      in: e,
      children: /* @__PURE__ */ o(a, {
        className: n,
        children: r
      })
    })
  });
};
export {
  x as default
};
//# sourceMappingURL=ModalBox.js.map
